import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ClientEnv } from 'constants/Chat.constants';

import { ClientEnvironment } from '@polyai/common/constants/global.constants';

import { createNewCall, projectInit } from 'actions';

export interface CallPanelState {
  isCallPanelOpen: boolean;
  clientEnv: ClientEnv;
  conversationId: string | null;
  variantName: string | null;
}

const initialState: CallPanelState = {
  isCallPanelOpen: false,
  clientEnv: ClientEnvironment.SANDBOX,
  conversationId: null,
  variantName: null,
};

const callPanelSlice = createSlice({
  name: 'callPanel',
  initialState,
  reducers: {
    openCallPanel: state => {
      state.isCallPanelOpen = true;
    },
    closeCallPanel: state => {
      state.isCallPanelOpen = false;
      state.conversationId = null;
    },
    toggleCallPanel: state => {
      state.isCallPanelOpen = !state.isCallPanelOpen;
    },
    setClientEnv: (state, { payload: clientEnv }: PayloadAction<ClientEnv>) => {
      state.clientEnv = clientEnv;
    },
    setVariantName: (
      state,
      { payload: variantName }: PayloadAction<string | null>,
    ) => {
      state.variantName = variantName;
    },
    setConversationId: (
      state,
      { payload: conversationId }: PayloadAction<string | null>,
    ) => {
      state.conversationId = conversationId;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(projectInit, () => {
        return { ...initialState };
      })
      .addCase(createNewCall, state => {
        state.isCallPanelOpen = true;
      });
  },
});

export const {
  openCallPanel,
  closeCallPanel,
  toggleCallPanel,
  setClientEnv,
  setVariantName,
  setConversationId,
} = callPanelSlice.actions;

export default callPanelSlice.reducer;
